export default __webpack_public_path__ + "static/media/Dr.09e4761d.png";